<template>
  <div class="main-container">
    <div class="feeds-control">
      <div class="feeds-control__left">
        <main-menu></main-menu>
      </div>
      <div class="feeds-control__right">
        <div class="feed-control-panel">
          <h2 class="main-title">Feeds</h2>
          <Loader v-if="isGamesLoadInProgress"></Loader>
          <div v-else class="column-control">
            <div class="column-control__wrap column-control__wrap--feed-control">
              <div class="column-control__left">
                <FeedsList :chosen-feed="chosenFeed"
                           v-on:choseFeed="onChooseFeed"
                           v-on:gettingFeed="onGettingFeed"
                           ref="feedsList"
                />
              </div>
              <div class="column-control__right">

                <FeedGames :chosen-feed="chosenFeed"
                           :chooseFeed="chooseFeed"
                           :games="allGames"
                           ref="feedGames"></FeedGames>
              </div>
            </div>
            <div class="btns-row__right-btns">
              <button
                v-if="chosenFeed && $checkRoles(['Administrator'])"
                class="ark-btn ark-btn--success"
                @click="deletePopup">
                <Loader v-if="isFeedSaveInProgress"></Loader>
                <span v-else>Delete Feed</span>
              </button>
              <button v-if="chosenFeed && $checkRoles(['Administrator'])"
                      class="ark-btn ark-btn--success"
                      @click="save">
                <Loader v-if="isFeedSaveInProgress"></Loader>
                <span v-else>Save Feed</span>
              </button>
              <button v-if="!chosenFeed && $checkRoles(['Administrator'])"
                      class="ark-btn ark-btn--success"
                      @click="create">
                <Loader v-if="isFeedSaveInProgress"></Loader>
                <span v-else>Create Feed</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <InfoModal
      v-if="feedActionCompleteInfoModalShow"
      :msg="feedActionCompleteInfoModalMessage"
      :onCloseModal="closeInfoModal"
    ></InfoModal>
    <DeleteModal v-if="isDeleteModalVisible"
                 :itemToDel="chosenFeed.name"
                 v-on:submit="deleteFeed"
                 v-on:close="isDeleteModalVisible = false"
    ></DeleteModal>
  </div>
</template>

<script>
import Loader from '../../Loader/Loader.vue'
import InfoModal from '../../InfoModal/InfoModal.vue'
import DeleteModal from '../../DeleteModal/DeleteModal.vue'
import FeedsList from '../FeedsList/FeedsList.vue'
import FeedGames from '../FeedsGames/FeedGames.vue'
import MainMenu from '../../MainMenu/MainMenu.vue'

export default {
  name: 'FeedsControlMain',
  components: {MainMenu, Loader, DeleteModal, InfoModal, FeedsList, FeedGames},
  data() {
    return {
      isFeedSaveInProgress: false,
      isFeedDeleteInProgress: false,
      isGamesLoadInProgress: false,
      feedActionCompleteInfoModalShow: false,
      feedActionCompleteInfoModalMessage: '',
      chosenFeed: null,
      allGames: [],
      isDeleteModalVisible: false,
      successMsgs: [],
      feeds: []
    }
  },
  created: function () {
    this.getAllGames()
  },
  methods: {
    onChooseFeed: function (feed) {
      debugger
      this.chooseFeed(feed)
      this.$refs.feedGames.getChosenFeedGames(feed)
    },
    onGettingFeed: function (feeds) {
      this.feeds = feeds
    },
    chooseFeed: function (feed) {
      this.chosenFeed = feed
    },
    getAllGames: async function () {
      this.isGamesLoadInProgress = true
      // get all games with all versions
      this.allGames = await this.$gameApi.get('/games');
      this.isGamesLoadInProgress = false
    },
    create: async function () {
      let feedName = this.$refs.feedGames.getFeedName();
      if (!feedName) return;
      let model = {
        name: feedName,
        environment: (process.env.NODE_ENV === 'live' || process.env.NODE_ENV === 'feature-live') ? 'Production' : 'Development'
      }
      try {
        const data = await this.$gameApi.post('/feeds', model);
        await this.$refs.feedsList.getFeeds();
        this.onChooseFeed(data);
        this.showInfoModal(`Feed ${feedName} is successfully created.`);
      } catch (error) {
        console.log(error)
        this.showInfoModal(`Feed ${feedName} is not created.`);
      }
    },
    save: function () {
      this.$refs.feedGames.validateForm().then((isValid) => {
        if (isValid) {
          this.isFeedSaveInProgress = true // showing loader
          Promise.all([
            Promise.all(this.$refs.feedGames.getGamesToFeed().map(g => this.$gameApi.post(`/feeds/${this.chosenFeed.id}/games/${g.id}`, {}))),
            Promise.all(this.$refs.feedGames.getGamesToDeleteFromFeed().map(g => this.this.$gameApi.delete(`/feeds/${this.chosenFeed.id}/games/${g.id}`))),
          ]).then(() => {
            this.isFeedSaveInProgress = false
            this.showInfoModal(`${this.chosenFeed.name} is successfully updated.`)
            this.$refs.feedsList.getFeeds()
          }).catch(() => {
            this.showInfoModal(`Something went wrong`);
          })
        }
      })
    },
    deletePopup: function () {
      this.isDeleteModalVisible = true
    },
    deleteFeed: function () {
      this.isDeleteModalVisible = false
      this.isFeedDeleteInProgress = true

      this.$gameApi.delete(`/feeds/${this.chosenFeed.id}`)
        .then(() => {
          this.showInfoModal(`${this.chosenFeed.name} is successfully deleted.`)
          this.chosenFeed = null
          this.isFeedDeleteInProgress = false
          this.$refs.feedsList.getFeeds()
        }, error => {
          console.log(error)
          this.isFeedDeleteInProgress = false
        })
    },
    closeInfoModal: function () {
      this.feedActionCompleteInfoModalShow = false
    },
    showInfoModal: function (message) {
      this.feedActionCompleteInfoModalMessage = message
      this.feedActionCompleteInfoModalShow = true
    }
  }
}
</script>

<style scoped src="./FeedsControlMain.scss" lang="scss"></style>
